import React from "react"
import { BsInfoCircleFill } from "react-icons/bs"
import ReactTooltip from "react-tooltip"

const selectedSubitemClass =
  "selected-submenu-item model-page-navigation-submenu-item"

const PageButton = ({
  displayName,
  path,
  onClick,
  tooltip = "",
  selected = false,
  id,
}) => {
  let openLinkInNewTab = false

  try {
    if (window) {
      const params = new URL(path, window.location.origin).searchParams
      openLinkInNewTab = params.get("new_tab") === "true"
    }
  } catch (err) {
    console.log("error parsing relative path")
  }

  return (
    <div className="submenu-item-container" onClick={onClick}>
      <a
        data-cy={`model-page-navigation-submenu-item`}
        className={
          selected ? selectedSubitemClass : "model-page-navigation-submenu-item"
        }
        href={path}
        target={openLinkInNewTab ? "_blank" : undefined}
        rel="noreferrer"
      >
        {displayName}
        {tooltip ? (
          <>
            <BsInfoCircleFill
              className="tooltip-icon"
              data-cy="tooltip-icon"
              data-tip={tooltip}
              data-for={`${id}`}
            />
            <ReactTooltip
              data-cy="tooltip"
              id={`${id}`}
              backgroundColor="#09283B"
              effect="solid"
            />
          </>
        ) : null}
      </a>
    </div>
  )
}

export default PageButton
